import { graphql } from 'gatsby';
import CTACardContent from './components/CTACardContent/CTACardContent';
import { Wrapper } from './CTACard.styles';
import MidPageFormContainer from '../MidPageFormContainer/MidPageFormContainer';

interface CTACardProps extends Queries.CTACARDFragment {
  className?: string;
}

const CTACard = ({ ctacardElements: elements, system, className }: CTACardProps) => {
  const type = elements.content.value.__typename;
  return (
    <Wrapper data-codename={system.codename} className={className}>
      {type === 'kontent_item_midpage_form_container' && (
        <MidPageFormContainer {...elements.content.value} />
      )}
      {type === 'kontent_item_cta_card_content' && <CTACardContent {...elements.content.value} />}
    </Wrapper>
  );
};

export const fragment = graphql`
  fragment CTACARD on kontent_item_ctacard {
    __typename
    system {
      codename
      id
    }
    ctacardElements: elements {
      content {
        value {
          ...MID_PAGE_FORM_CONTAINER
          ...CTA_CARD_CONTENT
        }
      }
    }
  }
`;

export default CTACard;
